/*
 * @Author: Roman
 * @Date: 2022-08-01 13:56:56
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2022-11-14 18:17:34
 * @FilePath: \qpmn-site\src\app\modules\product\model\domain\attribute\AttributeValue.ts
 * @Description: 
 */
import { AttributeOption } from "../data/AttributeOption";

export class Attribute {

    public id: number;

    public clazz: string = "com.qpp.cgp.domain.attribute.Attribute";

    public createdDate?: number;

    public createdBy?: string;

    public modifiedDate: number;

    public modifiedBy: string;

    public name: string;

    public required: boolean;

    public inputType: string;

    public validationExp: string;

    public options: Array<AttributeOption>;

    public code: string;

    public showInFrontend: boolean;

    public sortOrder: number;

    public valueType: string;

    public selectType: string;

    public multilingualKey: string = "com.qpp.cgp.domain.attribute.Attribute";
}

export class AttributeValue {

    attribute: Attribute;

    attributeId: number;

    clazz: string = "com.qpp.cgp.domain.product.ProductAttributeValue";

    id: number;

    createdBy?: string;

    createdDate?: number;

    modifiedDate?: number;

    multilingualKey: string = "com.qpp.cgp.domain.product.ProductAttributeValue";

    optionIds?: string;

    productId: number;

    value: string | Array<number>;

    isSku: boolean;

    skuAttributeId: number;

    skuAttributeCode: string;
    optionValues?:string;
}